import React, { Fragment, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import {
  useDailyLocationGalleryFeatureFlag,
  useMultiLocationGalleryFeatureFlag,
} from "../core/splitio";
import { useQueryString } from "../hooks";
import { OfferingMindspaceDailyOffice } from "./mindspace/offering_mindspace_daily_office";
import { OfferingMindspaceDayPass } from "./mindspace/offering_mindspace_daypass";
import { OfferingMindspaceMultiPass } from "./mindspace/offering_mindspace_multipass";
import { OfferingNomadworksDayOffice } from "./nomadworks/offering_nomadworks_day_office";
import { OfferingNomadworksDayPass } from "./nomadworks/offering_nomadworks_daypass";
import { OfferingNomadworksListingMeetingRoom } from "./nomadworks/offering_nomadworks_listing_meeting_room";
import { OfferingNomadworksMultiPass } from "./nomadworks/offering_nomadworks_multipass";
import { offeringConfig } from "./offering_config";
import { OfferingTheYardDayPass } from "./theyard/offering_theyard_daypass";
import { OfferingTheYardMultiPass } from "./theyard/offering_theyard_multipass";
import { OfferingWerqwiseDayOffice } from "./werqwise/offering_werqwise_day_office";
import { OfferingWerqwiseDayPass } from "./werqwise/offering_werqwise_daypass";
import { OfferingWerqwiseListingMeetingRoom } from "./werqwise/offering_werqwise_listing_meeting_room";
import { OfferingWerqwiseMultiPass } from "./werqwise/offering_werqwise_multipass";
import { OfferingWeWorkDailyAccess } from "./wework/offering_wework_daily_access";
import { OfferingWeWorkDayPass } from "./wework/offering_wework_daypass";
import { OfferingWeWorkListingDailyAccess } from "./wework/offering_wework_listing_daily_access";
import { OfferingWeWorkListingDayOffice } from "./wework/offering_wework_listing_day_office";
import { OfferingWeWorkListingDayPass } from "./wework/offering_wework_listing_daypass";
import { OfferingWeWorkListingMeetingRoom } from "./wework/offering_wework_listing_meeting_room";
import { OfferingWeWorkListingMultiPass } from "./wework/offering_wework_listing_multipass";
import { OfferingWeWorkMultiPass } from "./wework/offering_wework_multipass";
import { OfferingUrbanplaceDayPass } from "./urbanplace/offering_urbanplace_daypass";
import { OfferingUrbanplaceDayDeskPass } from "./urbanplace/offering_urbanplace_day_desk_pass";
import { OfferingUrbanplaceDayOfficePass } from "./urbanplace/offering_urbanplace_day_office_pass";
import { OfferingUrbanplaceMultiPass } from "./urbanplace/offering_urbanplace_multipass";
import { OfferingUrbanplaceDeskMultiPass } from "./urbanplace/offering_urbanplace_desk_multipass";
import { OfferingUrbanplaceListingMeetingRoom } from "./urbanplace/offering_urbanplace_listing_meeting_room";
import { OfferingTheMalinMultiPass } from "./themalin/offering_themalin_multipass";
import { OfferingTheMalinDayPass } from "./themalin/offering_themalin_daypass";
import { OfferingTheMalinListingMeetingRoom } from "./themalin/offering_themalin_listing_meeting_room";
import { OfferingCubicoDayPass } from "./cubico/offering_cubico_daypass";
import { OfferingCubicoDailyOffice } from "./cubico/offering_cubico_daily_office";
import { OfferingCubicoMultiPass } from "./cubico/offering_cubico_multipass";
import { OfferingLuminaryDayPass } from "./luminary/offering_luminary_daypass";
import { OfferingLuminaryMultiPass } from "./luminary/offering_luminary_multipass";
import { OfferingLuminaryListingMeetingRoom } from "./luminary/offering_luminary_listing_meeting_room";
import { OfferingLuminaryDayOffice } from "./luminary/offering_luminary_day_office";
import { OfferingDiwanHubDayPass } from "./diwan-hub/offering_diwan_hub_daypass";
import { OfferingDiwanHubMultiPass } from "./diwan-hub/offering_diwan_hub_multipass";
import { OfferingDiwanHubListingMeetingRoom } from "./diwan-hub/offering_diwan_hub_listing_meeting_room";
import { OfferingTeamworkingDayPass } from "./teamworking/offering_teamworking_daypass";
import { OfferingTeamworkingMultiPass } from "./teamworking/offering_teamworking_multipass";
import { OfferingMDotDayPass } from "./mdot/offering_mdot_daypass";
import { OfferingMDotMultiPass } from "./mdot/offering_mdot_multipass";
import { OfferingMDotDayOffice } from "./mdot/offering_mdot_day_office";
import { OfferingMDotListingMeetingRoom } from "./mdot/offering_mdot_listing_meeting_room";
import { OfferingWeWorkListingClassroom } from "./wework/offering_wework_listing_classroom";
import { OfferingLuminaryMultiDayOffice } from "./luminary/offering_luminary_multi_day_office";
import { OfferingMercuryCenterDayPass } from "./mercury-center/offering_mercury_center_daypass";
import { OfferingMercuryCenterMultiPass } from "./mercury-center/offering_mercury_center_multipass";
import { OfferingMercuryCenterDayOffice } from "./mercury-center/offering_mercury_center_day_office";
import { OfferingMercuryCenterListingMeetingRoom } from "./mercury-center/offering_mercury_center_listing_meeting_room";
import { OfferingBondCollectiveDayPass } from "./bond-collective/offering_bond_collective_daypass";
import { OfferingCoalitionSpaceDayPass } from "./coalition-space/offering_coalition_space_daypass";
import { OfferingCoalitionSpaceMultiPass } from "./coalition-space/offering_coalition_space_multipass";
import { OfferingCoalitionSpaceListingMeetingRoom } from "./coalition-space/offering_coalition_space_listing_meeting_room";
import { OfferingRoomsDayPass } from "./rooms/offering_rooms_daypass";
import { OfferingRoomsMultiPass } from "./rooms/offering_rooms_multipass";
import { OfferingRoomsDayOffice } from "./rooms/offering_rooms_day_office";
import { OfferingRoomsListingMeetingRoom } from "./rooms/offering_rooms_listing_meeting_room";
import { OfferingTheYardListingMeetingRoom } from "./theyard/offering_theyard_listing_meeting_room";
import { OfferingTheYardCreditPackages } from "./theyard/offering_theyard_credit_packages";
import { OfferingFoundrSpaceDayPass } from "./foundrspace/offering_foundrspace_daypass";
import { OfferingFoundrSpaceMultiPass } from "./foundrspace/offering_foundrspace_multipass";
import { OfferingFoundrSpaceListingMeetingRoom } from "./foundrspace/offering_foundrspace_listing_meeting_room";
import { OfferingFoundrSpaceDailyDeskPass } from "./foundrspace/offering_foundrspace_daily_desk_pass";
import { OfferingFoundrSpaceDayOffice } from "./foundrspace/offering_foundrspace_day_office";
import { OfferingBrainEmbassyDayPass } from "./brain-embassy/offering_brain-embassy_daypass";
import { OfferingBrainEmbassyMultiPass } from "./brain-embassy/offering_brain-embassy_multipass";
import { OfferingBrainEmbassyDayOffice } from "./brain-embassy/offering_brain-embassy_day_office";
import { OfferingBrainEmbassyListingMeetingRoom } from "./brain-embassy/offering_brain-embassy_listing_meeting_room";
import { OfferingMindspaceListingMeetingRoom } from "./mindspace/offering_mindspace_listing_meeting_room";
import { OfferingRoomsDailyAccess } from "./rooms/offering_rooms_daily_access";
import { OfferingRentryDayPass } from "./rentry/offering_rentry_daypass";
import { OfferingRentryMultiPass } from "./rentry/offering_rentry_multipass";
import { OfferingRentryListingMeetingRoom } from "./rentry/offering_rentry_listing_meeting_room";
import { OfferingRentryDayDeskPass } from "./rentry/offering_rentry_day_desk_pass";
import { OfferingVillageWorkspacesDayPass } from "./village-workspaces/offering_village_workspaces_daypass";
import { OfferingVillageWorkspacesDayOffice } from "./village-workspaces/offering_village_workspaces_day_office";
import { OfferingVillageWorkspacesMultiPass } from "./village-workspaces/offering_village_workspaces_multipass";
import { OfferingVillageWorkspacesMultiDayOffice } from "./village-workspaces/offering_village_workspaces_multi_day_office";
import { OfferingVillageWorkspacesListingMeetingRoom } from "./village-workspaces/offering_village_workspaces_listing_meeting_room";
import { OfferingMindWareHouseDayOffice } from "./mindwarehouse/offering_mindwarehouse_day_office";
import { OfferingMindWareHouseDayPass } from "./mindwarehouse/offering_mindwarehouse_daypass";
import { OfferingMindWareHouseMultiPass } from "./mindwarehouse/offering_mindwarehouse_multipass";
import { OfferingMindWareHouseListingMeetingRoom } from "./mindwarehouse/offering_mindwarehouse_listing_meeting_room";
import { OfferingEthosSocietyDayOffice } from "./ethos-society/offering_ethos_society_day_office";
import { OfferingEthosSocietyDayPass } from "./ethos-society/offering_ethos_society_daypass";
import { OfferingEthosSocietyMultiPass } from "./ethos-society/offering_ethos_society_multipass";
import { OfferingEthosSocietyListingMeetingRoom } from "./ethos-society/offering_ethos_society_listing_meeting_room";
import { OfferingTheMalinDedicatedDeskMultiPass } from "./themalin/offering_themalin_dedicated_desk_multipass";
import { OfferingBeyondPostalDayPass } from "./beyond-postal/offering_beyond_postal_daypass";
import { OfferingBeyondPostalMultiPass } from "./beyond-postal/offering_beyond_postal_multipass";
import { OfferingBeyondPostalListingMeetingRoom } from "./beyond-postal/offering_beyond_postal_listing_meeting_room";
import { OfferingTrellisDayOffice } from "./trellis/offering_trellis_day_office";
import { OfferingTrellisDayPass } from "./trellis/offering_trellis_daypass";
import { OfferingTrellisMultiPass } from "./trellis/offering_trellis_multipass";
import { OfferingTrellisListingMeetingRoom } from "./trellis/offering_trellis_listing_meeting_room";
import { OfferingRoomsExecutiveOffice } from "./rooms/offering_rooms_executive_office";
import { OfferingTheMalinDailyDeskPass } from "./themalin/offering_themalin_daily_desk_pass";
import { OfferingTheMalinMonthlyAccess } from "./themalin/offering_themalin_monthly_access";
import { OfferingDetails as OfferingDetailsV2 } from "../offering_v2/pages/offering_details";
import { useGetLightPartnerOffering } from "../data/api";
import { LightPartnerOffering, Template } from "../data/partner_offering";
import { useLocation } from "react-router";
import { useAnalytics } from "../lib/analytics/analytics";
import { DiscountPopupProvider } from "@/core/discount_popup_provider";

interface OfferingPageParams {
  offeringID: string;
}

export interface OfferingPageQueryParams {
  spaceID?: string;
  partnerOfferingLocationID?: string;
  startDate?: string;
  endDate?: string;
  quantity?: string;
  capacity?: string;
  addOnID?: string;
  spaceOfferingID?: string;
  startTime?: string;
  endTime?: string;
  date?: string;
  promoCode?: string;
  physicalSpaceID?: string;
  city?: string;
  attendees?: string;
  locationID?: string;
  membershipID?: string;
  subscriptionInterval?: string;
  subscriptionStartDate?: string;
  eventTypeID?: string;
  eventTypeDescription?: string;
  layoutID?: string;
  email?: string;
}

export function OfferingPage() {
  const pageParams = useParams<OfferingPageParams>();
  const partnerOfferingSlug = pageParams.offeringID;
  const partnerOffering = useGetLightPartnerOffering(partnerOfferingSlug);
  const isUsingOfferingV2 = [
    Template.DailyAccessV2.toString(),
    Template.DailyOffice.toString(),
    Template.MeetingRoomV2.toString(),
    Template.AddOnV2.toString(),
    Template.Membership,
    Template.EventSpace,
  ].includes(partnerOffering.template);

  return (
    <DiscountPopupProvider partnerId={partnerOffering.partner.id}>
      {isUsingOfferingV2 ? (
        <OfferingDetailsV2 partnerOffering={partnerOffering} />
      ) : (
        <OfferingDetailsV1 partnerOfferingSlug={partnerOfferingSlug} />
      )}
      <OfferingPageTracker partnerOffering={partnerOffering} />
    </DiscountPopupProvider>
  );
}

function OfferingDetailsV1(props: { partnerOfferingSlug: string }) {
  const dailyLocationGalleryFeatureFlag = useDailyLocationGalleryFeatureFlag();
  const multiLocationGalleryFeatureFlag = useMultiLocationGalleryFeatureFlag();
  const qs = useQueryString<OfferingPageQueryParams>();

  if (
    props.partnerOfferingSlug === offeringConfig.Mindspace.slugConfig.dayPass ||
    props.partnerOfferingSlug ===
      offeringConfig.Mindspace.slugConfig.dayPassGermany
  ) {
    return <OfferingMindspaceDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Mindspace.slugConfig.multiPass
  ) {
    return <OfferingMindspaceMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
      offeringConfig.Mindspace.slugConfig.dayOffice ||
    props.partnerOfferingSlug ===
      offeringConfig.Mindspace.slugConfig.dayOfficeGermany
  ) {
    return <OfferingMindspaceDailyOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Mindspace.slugConfig.meetingRooms
  ) {
    return <OfferingMindspaceListingMeetingRoom />;
  } else if (props.partnerOfferingSlug === "nomadworks-day-pass") {
    return <OfferingNomadworksDayPass />;
  } else if (props.partnerOfferingSlug === "nomadworks-multi-pass") {
    return <OfferingNomadworksMultiPass />;
  } else if (props.partnerOfferingSlug === "nomadworks-day-office") {
    return <OfferingNomadworksDayOffice />;
  } else if (props.partnerOfferingSlug === "nomadworks-meeting-rooms") {
    return <OfferingNomadworksListingMeetingRoom />;
  } else if (props.partnerOfferingSlug === "wework-day-pass") {
    if (dailyLocationGalleryFeatureFlag) {
      if (qs.spaceID) {
        return <OfferingWeWorkDayPass />;
      }
      return <OfferingWeWorkListingDayPass />;
    }
    return <OfferingWeWorkDayPass />;
  } else if (props.partnerOfferingSlug === "wework-meeting-rooms") {
    return <OfferingWeWorkListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.WeWork.slugConfig.classroom
  ) {
    return <OfferingWeWorkListingClassroom />;
  } else if (props.partnerOfferingSlug === "wework-multi-pass") {
    if (multiLocationGalleryFeatureFlag) {
      if (qs.spaceID) {
        return <OfferingWeWorkMultiPass />;
      }
      return <OfferingWeWorkListingMultiPass />;
    }
    return <OfferingWeWorkMultiPass />;
  } else if (props.partnerOfferingSlug === "wework-day-office") {
    return <OfferingWeWorkListingDayOffice />;
  } else if (props.partnerOfferingSlug === "wework-daily-access") {
    if (qs.spaceID) {
      return <OfferingWeWorkDailyAccess />;
    }
    return <OfferingWeWorkListingDailyAccess />;
  } else if (props.partnerOfferingSlug === "werqwise-day-pass") {
    return <OfferingWerqwiseDayPass />;
  } else if (props.partnerOfferingSlug === "werqwise-meeting-rooms") {
    return <OfferingWerqwiseListingMeetingRoom />;
  } else if (props.partnerOfferingSlug === "werqwise-multi-pass") {
    return <OfferingWerqwiseMultiPass />;
  } else if (props.partnerOfferingSlug === "werqwise-day-office") {
    return <OfferingWerqwiseDayOffice />;
  } else if (props.partnerOfferingSlug === "theyard-day-pass") {
    return <OfferingTheYardDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.TheYard.slugConfig.multiPass
  ) {
    return <OfferingTheYardMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.TheYard.slugConfig.creditPackages
  ) {
    return <OfferingTheYardCreditPackages />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.TheYard.slugConfig.meetingRooms
  ) {
    return <OfferingTheYardListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Urbanplace.slugConfig.dayPass
  ) {
    return <OfferingUrbanplaceDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Urbanplace.slugConfig.dayDeskPass
  ) {
    return <OfferingUrbanplaceDayDeskPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Urbanplace.slugConfig.dayOffice
  ) {
    return <OfferingUrbanplaceDayOfficePass />;
  } else if (
    props.partnerOfferingSlug ===
      offeringConfig.Urbanplace.slugConfig.multiPass ||
    props.partnerOfferingSlug ===
      offeringConfig.Urbanplace.slugConfig.officeMultiPass
  ) {
    return <OfferingUrbanplaceMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Urbanplace.slugConfig.deskMultiPass
  ) {
    return <OfferingUrbanplaceDeskMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Urbanplace.slugConfig.meetingRooms
  ) {
    return <OfferingUrbanplaceListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.TheMalin.slugConfig.dayPass
  ) {
    return <OfferingTheMalinDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.TheMalin.slugConfig.multiPass
  ) {
    return <OfferingTheMalinMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.TheMalin.slugConfig.dedicatedDeskMultiPass
  ) {
    return <OfferingTheMalinDedicatedDeskMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.TheMalin.slugConfig.meetingRooms
  ) {
    return <OfferingTheMalinListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.TheMalin.slugConfig.dailyDeskPass
  ) {
    return <OfferingTheMalinDailyDeskPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.TheMalin.slugConfig.monthlyAccess
  ) {
    return <OfferingTheMalinMonthlyAccess />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Cubico.slugConfig.dayPass
  ) {
    return <OfferingCubicoDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Cubico.slugConfig.dailyOffice
  ) {
    return <OfferingCubicoDailyOffice />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Cubico.slugConfig.multiPass
  ) {
    return <OfferingCubicoMultiPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Luminary.slugConfig.dayPass
  ) {
    return <OfferingLuminaryDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Luminary.slugConfig.dayOffice
  ) {
    return <OfferingLuminaryDayOffice />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Luminary.slugConfig.multiPass
  ) {
    return <OfferingLuminaryMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Luminary.slugConfig.multiDayOffice
  ) {
    return <OfferingLuminaryMultiDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Luminary.slugConfig.meetingRooms
  ) {
    return <OfferingLuminaryListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.DiwanHub.slugConfig.dayPass
  ) {
    return <OfferingDiwanHubDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.DiwanHub.slugConfig.multiPass
  ) {
    return <OfferingDiwanHubMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.DiwanHub.slugConfig.meetingRooms
  ) {
    return <OfferingDiwanHubListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Teamworking.slugConfig.dayPass
  ) {
    return <OfferingTeamworkingDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Teamworking.slugConfig.multiPass
  ) {
    return <OfferingTeamworkingMultiPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.MDot.slugConfig.dayPass
  ) {
    return <OfferingMDotDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.MDot.slugConfig.multiPass
  ) {
    return <OfferingMDotMultiPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.MDot.slugConfig.dayOffice
  ) {
    return <OfferingMDotDayOffice />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.MDot.slugConfig.meetingRooms
  ) {
    return <OfferingMDotListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MercuryCenter.slugConfig.dayPass
  ) {
    return <OfferingMercuryCenterDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MercuryCenter.slugConfig.multiPass
  ) {
    return <OfferingMercuryCenterMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MercuryCenter.slugConfig.dayOffice
  ) {
    return <OfferingMercuryCenterDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MercuryCenter.slugConfig.meetingRooms
  ) {
    return <OfferingMercuryCenterListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.BondCollective.slugConfig.dayPass
  ) {
    return <OfferingBondCollectiveDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.CoalitionSpace.slugConfig.dayPass
  ) {
    return <OfferingCoalitionSpaceDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.CoalitionSpace.slugConfig.multiPass
  ) {
    return <OfferingCoalitionSpaceMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.CoalitionSpace.slugConfig.meetingRooms
  ) {
    return <OfferingCoalitionSpaceListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rooms.slugConfig.dayPass
  ) {
    return <OfferingRoomsDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rooms.slugConfig.multiPass
  ) {
    return <OfferingRoomsMultiPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rooms.slugConfig.dailyAccess
  ) {
    return <OfferingRoomsDailyAccess />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rooms.slugConfig.dayOffice
  ) {
    return <OfferingRoomsDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.Rooms.slugConfig.executiveOffice
  ) {
    return <OfferingRoomsExecutiveOffice />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rooms.slugConfig.meetingRooms
  ) {
    return <OfferingRoomsListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.FoundrSpace.slugConfig.dayPass
  ) {
    return <OfferingFoundrSpaceDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.FoundrSpace.slugConfig.multiPass
  ) {
    return <OfferingFoundrSpaceMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.FoundrSpace.slugConfig.meetingRooms
  ) {
    return <OfferingFoundrSpaceListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.FoundrSpace.slugConfig.dailyDeskPass
  ) {
    return <OfferingFoundrSpaceDailyDeskPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.FoundrSpace.slugConfig.dayOffice
  ) {
    return <OfferingFoundrSpaceDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.BrainEmbassyNew.slugConfig.dayPass
  ) {
    return <OfferingBrainEmbassyDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.BrainEmbassyNew.slugConfig.multiPass
  ) {
    return <OfferingBrainEmbassyMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.BrainEmbassyNew.slugConfig.dayOffice
  ) {
    return <OfferingBrainEmbassyDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.BrainEmbassyNew.slugConfig.meetingRooms
  ) {
    return <OfferingBrainEmbassyListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rentry.slugConfig.dayDeskPass
  ) {
    return <OfferingRentryDayDeskPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rentry.slugConfig.dayPass
  ) {
    return <OfferingRentryDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rentry.slugConfig.multiPass
  ) {
    return <OfferingRentryMultiPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Rentry.slugConfig.meetingRooms
  ) {
    return <OfferingRentryListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.VillageWorkspaces.slugConfig.dayPass
  ) {
    return <OfferingVillageWorkspacesDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.VillageWorkspaces.slugConfig.dayOffice
  ) {
    return <OfferingVillageWorkspacesDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.VillageWorkspaces.slugConfig.multiPass
  ) {
    return <OfferingVillageWorkspacesMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.VillageWorkspaces.slugConfig.multiDayOffice
  ) {
    return <OfferingVillageWorkspacesMultiDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.VillageWorkspaces.slugConfig.meetingRooms
  ) {
    return <OfferingVillageWorkspacesListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MindWareHouse.slugConfig.dayOffice
  ) {
    return <OfferingMindWareHouseDayOffice />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MindWareHouse.slugConfig.dayPass
  ) {
    return <OfferingMindWareHouseDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MindWareHouse.slugConfig.multiPass
  ) {
    return <OfferingMindWareHouseMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.MindWareHouse.slugConfig.meetingRooms
  ) {
    return <OfferingMindWareHouseListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.EthosSociety.slugConfig.dayOffice
  ) {
    return <OfferingEthosSocietyDayOffice />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.EthosSociety.slugConfig.dayPass
  ) {
    return <OfferingEthosSocietyDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.EthosSociety.slugConfig.multiPass
  ) {
    return <OfferingEthosSocietyMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.EthosSociety.slugConfig.meetingRooms
  ) {
    return <OfferingEthosSocietyListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.BeyondPostal.slugConfig.dayPass
  ) {
    return <OfferingBeyondPostalDayPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.BeyondPostal.slugConfig.multiPass
  ) {
    return <OfferingBeyondPostalMultiPass />;
  } else if (
    props.partnerOfferingSlug ===
    offeringConfig.BeyondPostal.slugConfig.meetingRooms
  ) {
    return <OfferingBeyondPostalListingMeetingRoom />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Trellis.slugConfig.dayOffice
  ) {
    return <OfferingTrellisDayOffice />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Trellis.slugConfig.dayPass
  ) {
    return <OfferingTrellisDayPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Trellis.slugConfig.multiPass
  ) {
    return <OfferingTrellisMultiPass />;
  } else if (
    props.partnerOfferingSlug === offeringConfig.Trellis.slugConfig.meetingRooms
  ) {
    return <OfferingTrellisListingMeetingRoom />;
  }

  return null;
}

function OfferingPageTracker(props: { partnerOffering: LightPartnerOffering }) {
  const location = useLocation();
  const re = new RegExp("/offerings/(.*?)-meeting-rooms$");
  const isMeetingRoomGallery = re.test(location.pathname);
  const { partnerOffering } = props;

  return useMemo(() => {
    if (
      isMeetingRoomGallery ||
      partnerOffering.slug === offeringConfig.WeWork.slugConfig.meetingRoom ||
      partnerOffering.slug === offeringConfig.WeWork.slugConfig.dailyAccess ||
      partnerOffering.slug === offeringConfig.WeWork.slugConfig.dayOffice ||
      partnerOffering.slug === offeringConfig.WeWork.slugConfig.classroom
    ) {
      return <OfferingListingPageTracker partnerOffering={partnerOffering} />;
    } else {
      return <OfferingDetailPageTracker partnerOffering={partnerOffering} />;
    }
  }, [isMeetingRoomGallery, partnerOffering]);
}

function OfferingListingPageTracker(props: {
  partnerOffering: LightPartnerOffering;
}) {
  const analytics = useAnalytics();
  const { pathname: pathName } = useLocation();
  const { template, partner } = props.partnerOffering;
  const { id, name, internalName } = partner;

  useEffect(() => {
    analytics.screen(
      "Gallery Page View",
      {
        partnerId: id,
        partnerName: name,
        partnerInternalName: internalName,
        pageName: "Gallery",
        template: template,
        Source: "WL",
      },
      { onlyProviders: ["mixpanel", "customerio"] }
    );
  }, [analytics, pathName, id, name, template, internalName]);

  return <Fragment />;
}

function OfferingDetailPageTracker(props: {
  partnerOffering: LightPartnerOffering;
}) {
  const analytics = useAnalytics();
  const { pathname: pathName } = useLocation();
  const {
    template,
    partner,
    name: partnerOfferingName,
  } = props.partnerOffering;
  const { id, internalName, name } = partner;

  useEffect(() => {
    analytics.screen(
      "Product Detail Page View",
      {
        partnerId: id,
        partnerName: name,
        partnerInternalName: internalName,
        pageName: "Product Detail",
        template: template,
        "Offering Name": partnerOfferingName,
        Source: "WL",
      },
      { onlyProviders: ["mixpanel", "customerio"] }
    );
  }, [
    analytics,
    pathName,
    id,
    name,
    template,
    partnerOfferingName,
    internalName,
  ]);

  return <Fragment />;
}
